import { render, staticRenderFns } from "./PaymentMethodAlert.vue?vue&type=template&id=473fb930"
import script from "./PaymentMethodAlert.vue?vue&type=script&lang=js"
export * from "./PaymentMethodAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports